module.exports = __webpack_public_path__ + "img/background.e0ee635a.png";